/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minLength: NonNullable<unknown> }} Passwordtooshorterror3Inputs */

const en_passwordtooshorterror3 = /** @type {(inputs: Passwordtooshorterror3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Password must be at least ${i?.minLength} characters`)
};

const de_passwordtooshorterror3 = /** @type {(inputs: Passwordtooshorterror3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passwort muss mindestens ${i?.minLength} Zeichen lang sein`)
};

/**
* | output |
* | --- |
* | "Password must be at least {minLength} characters" |
*
* @param {Passwordtooshorterror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordtooshorterror3 = /** @type {((inputs: Passwordtooshorterror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordtooshorterror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordtooshorterror3(inputs)
	return de_passwordtooshorterror3(inputs)
});
export { passwordtooshorterror3 as "passwordTooShortError" }